import { render } from "./mproductDtails.vue?vue&type=template&id=117f1d8f&scoped=true"
import script from "./mproductDtails.vue?vue&type=script&lang=js"
export * from "./mproductDtails.vue?vue&type=script&lang=js"

import "./mproductDtails.vue?vue&type=style&index=0&id=117f1d8f&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117f1d8f"]])

export default __exports__